<template>
  <section id="clients" class="hw-section hw-clients" style="padding-top: 0;">
    <div class="hw-container">
      <p class="hw-kicker">Confiança</p>
      <h2 class="hw-title">Quem já cresce connosco</h2>
      <p class="hw-lead">
        Equipas e marcas que usam o software que construímos, sobretudo através do MKGest.
      </p>
    </div>
    <div class="hw-marquee">
      <div class="hw-marquee-track">
        <div class="hw-client" v-for="(logo, index) in looped" :key="index">
          <img :src="logo" alt="Cliente Hardwired" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import clients from "../data/clients";

export default {
  data() {
    return {
      clients,
    };
  },
  computed: {
    looped() {
      return this.clients.concat(this.clients);
    },
  },
};
</script>
